<template>
  <v-card>
    <alert-error :error="error" />
    <v-card-text>
      <user-notifications :notifications="notifications || []" />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'UserNotificationsPage',

  components: {
    AlertError: () => import('@/modules/_global/_components/AlertError'),
    UserNotifications: () =>
      import('@/modules/notifications/components/UserNotifications.vue')
  },

  props: {
    userId: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    notifications: [],
    error: null,
    unwatch: null
  }),

  created() {
    this.unwatch = this.$store.watch(
      state => state.localization.lang,
      () => {
        const lang = this.$store.state.localization.lang;

        if (lang) {
          this.getUserNotifications();
        }
      }
    );

    this.getUserNotifications();
  },

  destroyed() {
    this.unwatch();
  },

  methods: {
    getUserNotifications() {
      if(this.userId > 0){
        this.$store
                .dispatch('notification/retrieveUserNotifications', this.userId)
                .then(({ data }) => {
                  this.notifications = data.data;
                })
                .catch(error => {
                  this.error = error.response;
                });
      } else {
        this.notifications = [];
      }
    }
  }
};
</script>
